import { render, staticRenderFns } from "./PlaceTables.vue?vue&type=template&id=9de3a25e"
import script from "./PlaceTables.vue?vue&type=script&lang=js"
export * from "./PlaceTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports